import { useContext, useEffect } from 'react';

import { Button } from '@selina-finance/ui';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import { ApplicationContext } from '@src/app/contexts/Application';
import { toCurrency } from '@src/shared/helpers';
import { checkForDeclinedOffer } from '@src/shared/helpers/offer';
import CreditScoreDisclaimer from '@src/ui/components/CreditScoreDisclaimer/CreditScoreDisclaimer';
import Check3DIcon from '@src/ui/components/Icons/Check3DIcon';

const ApprovalView = () => {
    const navigate = useNavigate();

    const { loanDetails, offers, setHasDeclinedOffer } =
        useContext(ApplicationContext);

    const hasDeclined = checkForDeclinedOffer(offers);

    useEffect(() => {
        setHasDeclinedOffer(hasDeclined);
    }, [hasDeclined, setHasDeclinedOffer]);

    const path = `/eligibility/${
        hasDeclined ? 'offer/explore' : 'loan-preferences'
    }`;

    return (
        <motion.div
            initial={{ y: 300, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
                duration: 0.6,
                ease: [0.16, 1, 0.3, 1],
                delay: 0.2,
            }}
            className='flex flex-col mx-auto max-w-400 w-full h-full'
        >
            <div className='flex flex-col items-center'>
                <div className='mt-20 lg:mt-10 mb-8'>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.6 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{
                            type: 'spring',
                            stiffness: 500,
                            damping: 20,
                            delay: 0.4,
                        }}
                    >
                        <Check3DIcon />
                    </motion.div>
                </div>

                <h1 className='text-4xl font-sora-bold mb-3 leading-100 text-center'>
                    You're approved
                </h1>

                <p className='text-4xl font-sora-regular rounded px-1 bg-opacity-40 bg-peppermint-500 leading-120% text-center relative inline-block'>
                    for £{toCurrency(loanDetails.amount)}
                </p>
            </div>

            <div className='w-full mt-44 lg:mt-20'>
                <Button
                    color='secondary'
                    className='w-full mb-6 lg:max-w-400'
                    size='large'
                    onClick={() => navigate(path)}
                >
                    Personalise my quote
                </Button>

                <CreditScoreDisclaimer />
                <p className='text-xs leading-120% text-center mt-6 '>
                    Subject to underwriting
                </p>
            </div>
        </motion.div>
    );
};

export default ApprovalView;
